import { useContext, useEffect, useState } from 'react';
import {
  HeaderWrapper,
  Avatar,
  HeaderContainer,
  FlexRow,
  BrandLink,
  LogoBox,
  TitleColumn,
  MainTitle,
  SubTitle,
  LeftArea,
  RightArea,
  PrimaryButton,
  Pill,
  OutlinePill,
  UserName,
  UserMeta,
  PillRow,
  AvatarWrap,
  ActionCluster,
  MenuButton,
  MobileNavPanel,
  DesktopTabs,
} from './Header.styles';
import HeaderTabs from './HeaderTabs';
import { useLocation } from 'react-router';
import StudentIdModal from '../StudentIdModal/StudentIdModal';
import Popup from './Popup';
import { UserContext } from '../../context/UserContextBase';
import { emailFromName, toTitleCaseSingle } from '../../utils';
import { FaUniversity, FaUserGraduate } from 'react-icons/fa';
import { IoClose, IoMenu } from 'react-icons/io5';
import useIsMobile from '../../hooks/useIsMobile';

const Header = () => {
  const location = useLocation();
  const isMobile = useIsMobile();
  const [open, setOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const showPortalChrome = location.pathname === '/home' || location.pathname === '/settings';
  const { sessionData } = useContext(UserContext);

  const fullName = `${toTitleCaseSingle(sessionData?.givenNames || '')} ${toTitleCaseSingle(sessionData?.surname || '')}`;
  const portrait = sessionData?.portrait?.encodedImage || '';
  const portraitUrl = portrait
    ? `data:${portrait.startsWith('/9j/') ? 'image/jpeg' : 'image/png'};base64,${portrait}`
    : '';

  useEffect(() => {
    if (!isMobile) setMenuOpen(false);
  }, [isMobile]);

  return (
    <HeaderWrapper>
      <HeaderContainer>
        <LeftArea>
          <FlexRow>
            <BrandLink to="/home" aria-label="Branham University Portal — home">
              <LogoBox>
                <FaUniversity size={18} color="#fff" aria-hidden />
              </LogoBox>
              <TitleColumn>
                <MainTitle>Branham University</MainTitle>
                <SubTitle>University Portal</SubTitle>
              </TitleColumn>
            </BrandLink>

            {showPortalChrome && isMobile && (
              <MenuButton
                type="button"
                $open={menuOpen}
                aria-label={menuOpen ? 'Close navigation menu' : 'Open navigation menu'}
                aria-expanded={menuOpen}
                onClick={() => setMenuOpen((v) => !v)}
              >
                {menuOpen ? <IoClose size={22} /> : <IoMenu size={22} />}
              </MenuButton>
            )}

            {showPortalChrome && !isMobile && (
              <RightArea>
                <PrimaryButton onClick={() => setOpen(true)}>
                  <span aria-hidden style={{ fontSize: 16 }}>💳</span>
                  Get Digital Student ID
                </PrimaryButton>

                <UserMeta>
                  <UserName title={fullName}>{fullName}</UserName>
                  <PillRow>
                    <Pill>Junior</Pill>
                    <OutlinePill>Computer Science</OutlinePill>
                  </PillRow>
                </UserMeta>

                <AvatarWrap>
                  {portraitUrl ? (
                    <Avatar
                      onClick={() => setShowPopup((v) => !v)}
                      style={{ backgroundImage: `url(${portraitUrl})` }}
                      aria-label="Student profile"
                    />
                  ) : (
                    <Avatar onClick={() => setShowPopup((v) => !v)} aria-label="Student profile">
                      <FaUserGraduate size={22} color="#8A94A6" aria-hidden />
                    </Avatar>
                  )}
                  {showPopup && (
                    <Popup
                      name={fullName}
                      email={emailFromName(sessionData?.givenNames || '', sessionData?.surname || '')}
                      onCloseMenu={() => setShowPopup(false)}
                    />
                  )}
                </AvatarWrap>
              </RightArea>
            )}
          </FlexRow>

          {showPortalChrome && isMobile && (
            <RightArea>
              <UserMeta>
                <UserName title={fullName}>{fullName}</UserName>
              </UserMeta>

              <ActionCluster>
                <PrimaryButton onClick={() => setOpen(true)}>
                  <span aria-hidden style={{ fontSize: 14 }}>💳</span>
                  Get Digital Student ID
                </PrimaryButton>

                <AvatarWrap>
                  {portraitUrl ? (
                    <Avatar
                      onClick={() => setShowPopup((v) => !v)}
                      style={{ backgroundImage: `url(${portraitUrl})` }}
                      aria-label="Student profile"
                    />
                  ) : (
                    <Avatar onClick={() => setShowPopup((v) => !v)} aria-label="Student profile">
                      <FaUserGraduate size={20} color="#8A94A6" aria-hidden />
                    </Avatar>
                  )}
                  {showPopup && (
                    <Popup
                      name={fullName}
                      email={emailFromName(sessionData?.givenNames || '', sessionData?.surname || '')}
                      onCloseMenu={() => setShowPopup(false)}
                    />
                  )}
                </AvatarWrap>
              </ActionCluster>
            </RightArea>
          )}

          {showPortalChrome && !isMobile && (
            <DesktopTabs>
              <HeaderTabs />
            </DesktopTabs>
          )}

          {showPortalChrome && isMobile && (
            <MobileNavPanel $open={menuOpen} aria-hidden={!menuOpen}>
              <HeaderTabs vertical onSelect={() => setMenuOpen(false)} />
            </MobileNavPanel>
          )}
        </LeftArea>

        <StudentIdModal open={open} onClose={() => setOpen(false)} />
      </HeaderContainer>
    </HeaderWrapper>
  );
};

export default Header;
